import { TemplateType } from '@apply/constants';

export default {
    editTemplateModal: {
        isOpen: false,
    },
    editNotesModal: {
        isOpen: false,
    },
    editNameModal: {
        isOpen: false,
    },
};
